import { SheetProperties } from 'src/app/data/configurator/sheet/sheet-properties.data';
import { TemplatesLibrairie } from 'src/app/data/configurator/template/templates.librairie';
import { DesignsLibrairie } from 'src/app/data/configurator/design/designs.librairie';
import { LabelData } from 'src/app/data/configurator/label/label.data';
import { HistoryData } from 'src/app/data/configurator/history.data';
import { DesignData } from 'src/app/data/configurator/design/design.data';
import { EventEmitter } from '@angular/core';
import { ConfigurationEvent } from 'src/app/events/configuration.event';
import { Rectangle } from 'src/app/tools/rectangle';

export class Configuration {

  // add/remove label
  public onChange: EventEmitter<ConfigurationEvent> = new EventEmitter<ConfigurationEvent>();

  // select excel mode
  public onModeChange: EventEmitter<ConfigurationEvent> = new EventEmitter<ConfigurationEvent>();

  private _sheetData:any;
  private _designData:any;

  private _id:number;
  private _sheetId: number;
  private _productFamilyId: number;
  private _designFamilyId: number;

  // sheet data
  private _sheetProperties:SheetProperties;

  // librairies
  private _templates:TemplatesLibrairie;
  private _designs:DesignsLibrairie;
  private _labelsData:Array<LabelData>;

  private _mode:number;
  private _context:number;

  public mustControlOverlapseBeforePrint:boolean;

  // current label
  private _currentLabel: LabelData;

  private _csv:any;
  public currentLabelScreenRect:Rectangle;
  public currentCanvasRotation:number = 0;

  constructor(sheetData:any = null, designDataData:any = null) {

    this. _labelsData = [];

    if (sheetData && designDataData) {
      this.setData(sheetData, designDataData);
    }
  }

  /**
	 * data
	 */
  public setData(sheetData: any, designData: any):Promise<boolean> {
    this._sheetData = sheetData;
    this._designData = designData;
    // this._designData = {designFamilyCode:"BLANK"};

    return new Promise((resolve, reject) => {
      this._sheetProperties = new SheetProperties(this._sheetData);
      this._templates = new TemplatesLibrairie();

      this._templates.setData(this._sheetData.labelsDeclaration).then(
        (result: any) => {
          // console.log('Templates ready');

          this._designs = new DesignsLibrairie(this._designData);
          this._designs.setId(this._designData.designFamilyCode).then(
            (result: any) => {
              // console.log('Designs ready');
              resolve(true);
            },
            (error: any) => {
              console.log(error);
              reject(false);
            },
          ).catch((e: Error) => { console.error(e); reject(e); });

        },
        (error: any) => {
          console.log(error);
          reject(false);
        },
      ).catch((e: Error) => { console.error(e); reject(e); });;
    });
  }

  /**
	 * productFamilyId
	 */
  public get productFamilyId(): number {
    return this._productFamilyId;
  }
  public set productFamilyId(value: number) {
    this._productFamilyId = value;
  }

  /**
	 * designFamilyId
	 */
  public get designFamilyId(): number {
    return this._designFamilyId;
  }
  public set designFamilyId(value: number) {
    this._designFamilyId = value;
  }


  /**
	 * context
	 */
  public get context(): number {
    return this._context;
  }
  public set context(value: number) {
    this._context = value;
  }

  /**
	 * mode
	 */
  public get mode(): number {
    return this._mode;
  }
  public set mode(value: number) {
    if(value == this._mode) return;
    this._mode = value;
    this.onModeChange.emit(new ConfigurationEvent(ConfigurationEvent.MODE_CHANGE));
  }

  /**
	 * SheetId
	 */
  public get sheetId(): number {
    return this._sheetId;
  }
  public set sheetId(value: number) {
    this._sheetId = value;
  }

  /**
	 * Csv
	 */
  public get csv(): any {
    return this._csv;
  }
  public set csv(value: any) {
    this._csv = value;
  }

  /**
   * Add new sheet
   */
  public addSheet(): Promise<boolean[][]> {
    var label:LabelData;
    let promises: Array<Promise<boolean[]>> = [];
    for (var i:number = 0; i < this._sheetProperties.layouts.length; i++) {
      label = new LabelData();
      promises.push(label.setData(
        this._templates.getById(this._sheetProperties.layouts[i].templateID),
        this._designs.getByTemplateId(this._sheetProperties.layouts[i].templateID)
      ));
      this.labels.push(label);
    }

    return Promise.all(promises);
  }

  /**
   * Add new label
   */
  public addLabel(data:any = null): Promise<boolean> {

    // console.log("Configuration.addLabel()",data);
    return new Promise((resolve, reject) => {
      var label:LabelData = new LabelData();
      if (data) {
        let designData: DesignData = new DesignData();
        designData.setData(data).then(
          (result: any) => {
            // console.log("Configuration.addLabel() : DesignData.setData() resolve");
            label.setData(
              this._templates.getById(this._sheetProperties.layouts[this.labels.length % this._sheetProperties.layouts.length].templateID),
              designData
            ).then(
              (result: any) => {
                this.labels.push(label);
                this.onChange.emit(new ConfigurationEvent(ConfigurationEvent.ADD_LABEL));
                // console.log("Configuration.addLabel() : LabelData.setData() resolve");
                resolve(true);
              },
              (error: any) => {
                console.error(error);
              },
            ).catch((e: Error) => { console.error(e); });
          },
          (error: any) => {
            console.error(error);
            reject(false);
          },
        ).catch((e: Error) => { console.error(e); });
      } else {
        label.setData(
          this._templates.getById(this._sheetProperties.layouts[this.labels.length % this._sheetProperties.layouts.length].templateID),
          this._designs.getByTemplateId(this._sheetProperties.layouts[this.labels.length % this._sheetProperties.layouts.length].templateID)
        ).then(
          (result: any) => {
            // console.log("Configuration.addLabel() : LabelData.setData() resolve");
            this.labels.push(label);
            this.onChange.emit(new ConfigurationEvent(ConfigurationEvent.ADD_LABEL));
            resolve(true);
          },
          (error: any) => {
            console.error(error);
          }
        ).catch((e: Error) => { console.error(e); });
      }
    });
  }

  /**
   * Delete label
   */
  public deleteSheet(index: number): void {
    if (this.sheets.length == 1) {
      return;
    }

    for (var i: number = (index + 1) * this.sheetProperties.layouts.length - 1; i >= index * this.sheetProperties.layouts.length; i--) {
      this.deleteLabel(this.labels[i], false);
    }

    if (index == 0) {
      this.displayLabel(this.labels[0]);
    } else {
      this.displayLabel(this.labels[(index - 1) * this.sheetProperties.layouts.length]);
    }
  }

  /**
   * Delete label
   */
  public deleteLabel(labelData:LabelData, displayNext:boolean = true): void {
    if (this.labels.length == 1) {
      return;
    }

    var label: LabelData;
    for (var i: number = 0; i < this.labels.length; i++) {
      if (this.labels[i] == labelData) {
        label = this.labels[i];
        this.labels.splice(i, 1);
        break;
      }
    }

    //dispatchEvent(new ConfiguratorEvent(ConfiguratorEvent.REMOVE_LABEL, data));

    HistoryData.deleteLabel(labelData);
    labelData.cleanup();

    if (displayNext) {
      if (i == 0) {
        this.displayLabel(this.labels[0]);
      } else {
        this.displayLabel(this.labels[i - 1]);
      }
    }

    this.onChange.emit(new ConfigurationEvent(ConfigurationEvent.REMOVE_LABEL));
  }

  /**
		* Display label
		*/
  public displayLabel(label: LabelData): void {
    this._currentLabel = label;
  }

  /**
   * is Multiformat sheet
   */
  public get multiFormat():boolean {
    return this._templates.length > 1;
  }

  /**
   * Get labels
   */
  public get labels():Array<LabelData> {
    return this._labelsData;
  }

  /**
   * Get templateLibrary
   */
  public get templateLibrary():TemplatesLibrairie {
    return this._templates;
  }

  /**
   * Get sheets
   */
  public get sheets(): Array<any> {
    let l:Array<any> = [];
    for (let i: number = 0; i < Math.ceil(this.labels.length / this.sheetProperties.layouts.length); i++) {
      l.push('');
    }
    return l;
  }

  /**
	 * Get label
	 */
  public get currentLabel(): LabelData {
    return this._currentLabel;
  }

  /**
	 * labelRatio
	 */
  public get labelRatio(): number {
    return this._templates.getById(this._sheetProperties.layouts[this.labels.length % this._sheetProperties.layouts.length].templateID).width / this._templates.getById(this._sheetProperties.layouts[this.labels.length % this._sheetProperties.layouts.length].templateID).height;
  }

  /**
	 * sheetProperties
	 */
  public get sheetProperties(): SheetProperties {
    return this._sheetProperties;
  }

  /**
  * sheetData
  */
  public get sheetData(): any {
    return this._sheetData;
  }

  /**
	 * Get data
	 */
  public getData(): any {
    var returnData:Array<any> = [];
    for (let i = 0; i < this.labels.length; i++) {
      returnData.push(this.labels[i].getData());
    }
    return { labels: returnData };
  }

  /**
   * Cleanup
   */
  public cleanup():void {
    this._templates.cleanup();
    this._templates = null;
    this._sheetProperties.cleanup();
    this._sheetProperties = null;
    this._designs.cleanup();
    this._designs = null;
  }

}

export enum CONFIGURATION_CONTEXT {
	NEW = 1,
  SAVED = 2
}

export enum CONFIGURATION_MODE {
	NORMAL = 1,
  EXCEL = 2
}
